import type { PropsWithChildren } from "react"

import { Typography } from "@be-miniapp/ui/components/ui/typography"

const colorMapping = {
  green: {
    text: "#027C2C",
    background: "#DFF6DE",
  },
  red: {
    text: "#D70000",
    background: "#FFEDE4",
  },
  blue: {
    text: "#1A6CEA",
    background: "#CAE4FF",
  },
  yellow: {
    text: "#FFEB3B",
    background: "#FFF9C4",
  },
  purple: {
    text: "#4120A2",
    background: "#EAE3FE",
  },
  grey: {
    text: "#2D415E",
    background: "#E1E3E8",
  },
}

interface TagProps extends PropsWithChildren {
  color?: keyof typeof colorMapping
  bordered?: boolean
  textColor?: string
  backgroundColor?: string
}
const Tag = ({
  color = "green",

  children,
  textColor,
  backgroundColor,
}: TagProps) => {
  const colorData = colorMapping[color]

  return (
    <div
      style={{
        backgroundColor: backgroundColor ?? colorData.background,
      }}
      className="inline-flex items-center rounded-[4px] px-1.5"
    >
      <Typography.Caption
        size="medium"
        variant="semi"
        style={{
          color: textColor ?? colorData.text,
        }}
        className="shrink-0 py-0.5 leading-0"
      >
        {children}
      </Typography.Caption>
    </div>
  )
}

export { Tag }
